import { PropsWithChildren } from 'react';

export const TitleTag = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return (
    <span
      className={`px-3 h-[28px] leading-[28px] text-sm text-white rounded-xl ${className}`}
      style={{ backdropFilter: 'blur(6px)', background: 'rgba(0, 0, 0, 0.3)' }}
    >
      {children}
    </span>
  );
};
